import LANDING from './landpage/pt-BR';

const petModule = {
  LANDING,
};

export default petModule;
